import reportsConfig from './reportsConfig'

export default reportsConfig
